import React from 'react'

const UserSummary = ({user}) => {
  return (
    <h5 className="client_list_class">{user.name}</h5>   
  )
}

export default UserSummary
